import React, { Component } from "react"
import { BrowserRouter, Route, Switch } from "react-router-dom"
import { ROUTE_PATHS } from "./utils/routes"

import { ScrollToTopComponent, CcpaComponent } from "./components"
import { LayoutComponent, } from "./components/layout"
import {
  Contact,
  Home,
  Dashboard,
  Promotion,
  Register,
  StatusDetail,
  Thanks,
  Upload,
  Faq,
  ContactSuccess,
  NotFound,
  AuthenticatedRoute,
  SubmissionMethod,
  FirstResponders,
  SheerIdIFrame,
  AppleTV,
  AppleFitness,
  YouTubeTV,
  NursesTeachers,
  Philo,
  Paramount,
  Ooma,
  Google,
  SiriusXm,
  SheerIdIFrameNurseAndTeacher,
  Univision,
  Amazon,
  AAAPromo,
  Tidal
} from "./pages"
import { AppProvider } from "./components/context/AppContext"


class App extends Component {
  render() {
    return (
      <div className="App">
        <AppProvider>
          <BrowserRouter>
            <ScrollToTopComponent>
              <CcpaComponent>
                <LayoutComponent>
                  <Switch>
                    <AuthenticatedRoute exact path={ROUTE_PATHS.PROMOTION} component={Promotion} />
                    <AuthenticatedRoute exact path={ROUTE_PATHS.REGISTER} component={Register} />
                    <AuthenticatedRoute exact path={ROUTE_PATHS.UPLOAD} component={Upload} />
                    <AuthenticatedRoute exact path={ROUTE_PATHS.THANKS} component={Thanks} />
                    <AuthenticatedRoute exact path={ROUTE_PATHS.STATUS_DETAIL} component={StatusDetail} />
                    <AuthenticatedRoute exact path={ROUTE_PATHS.SUBMISSION_METHOD} component={SubmissionMethod} />
                    <Route exact path={ROUTE_PATHS.DASHBOARD} component={Dashboard} />
                    <Route exact path={ROUTE_PATHS.HOME} component={Home} />
                    <Route exact path={ROUTE_PATHS.OFFERSEARCH} component={Home} />
                    <Route exact path={ROUTE_PATHS.ORDERSEARCH} component={Home} />
                    <Route exact path={ROUTE_PATHS.TVONUS} component={Home} />
                    <Route exact path={ROUTE_PATHS.CONTACT} component={Contact} />
                    <Route exact path={ROUTE_PATHS.CONTACT_SUCCESS} component={ContactSuccess} />
                    <Route exact path={ROUTE_PATHS.FAQ} component={Faq} />
                    <Route exact path={ROUTE_PATHS.FIRSTRESPONDER} component={FirstResponders} />
                    <Route exact path={ROUTE_PATHS.SHEERIDIFRAME} component={SheerIdIFrame} />
                    <Route exact path={ROUTE_PATHS.APPLETV} component={AppleTV} />
                    <Route exact path={ROUTE_PATHS.APPLEFITNESS} component={AppleFitness} />
                    <Route exact path={ROUTE_PATHS.YOUTUBETV} component={YouTubeTV} />
                    <Route exact path={ROUTE_PATHS.NursesTeachers} component={NursesTeachers} />
                    <Route exact path={ROUTE_PATHS.PHILO} component={Philo} />
                    <Route exact path={ROUTE_PATHS.PARAMOUNT} component={Paramount} />
                    <Route exact path={ROUTE_PATHS.OOMA} component={Ooma} />
                    <Route exact path={ROUTE_PATHS.GOOGLE} component={Google} />
                    <Route exact path={ROUTE_PATHS.SIRIUSXM} component={SiriusXm} />
                    <Route exact path={ROUTE_PATHS.AAA} component={AAAPromo} />
                    <Route exact path={ROUTE_PATHS.SHEERIDIFRAMENURSEANDTEACHER} component={SheerIdIFrameNurseAndTeacher} />
                    <Route exact path={ROUTE_PATHS.UNIVISION} component={Univision} />
                    <Route exact path={ROUTE_PATHS.TIDAL} component={Tidal} />
                    <Route exact path={ROUTE_PATHS.AMAZON} component={Amazon} />
                    <Route component={NotFound} />
                  </Switch>
                </LayoutComponent>
              </CcpaComponent>
            </ScrollToTopComponent>
          </BrowserRouter>
        </AppProvider>
      </div>
    )
  }
}

export default App

